/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateOrUpdateMinimalBorrowerNaturalPersonDto } from './CreateOrUpdateMinimalBorrowerNaturalPersonDto';
import {
    CreateOrUpdateMinimalBorrowerNaturalPersonDtoFromJSON,
    CreateOrUpdateMinimalBorrowerNaturalPersonDtoFromJSONTyped,
    CreateOrUpdateMinimalBorrowerNaturalPersonDtoToJSON,
    CreateOrUpdateMinimalBorrowerNaturalPersonDtoToJSONTyped,
} from './CreateOrUpdateMinimalBorrowerNaturalPersonDto';
import type { CreateOrUpdateMinimalBorrowerLegalEntityDto } from './CreateOrUpdateMinimalBorrowerLegalEntityDto';
import {
    CreateOrUpdateMinimalBorrowerLegalEntityDtoFromJSON,
    CreateOrUpdateMinimalBorrowerLegalEntityDtoFromJSONTyped,
    CreateOrUpdateMinimalBorrowerLegalEntityDtoToJSON,
    CreateOrUpdateMinimalBorrowerLegalEntityDtoToJSONTyped,
} from './CreateOrUpdateMinimalBorrowerLegalEntityDto';
import type { SaveAnswerCommandDto } from './SaveAnswerCommandDto';
import {
    SaveAnswerCommandDtoFromJSON,
    SaveAnswerCommandDtoFromJSONTyped,
    SaveAnswerCommandDtoToJSON,
    SaveAnswerCommandDtoToJSONTyped,
} from './SaveAnswerCommandDto';

/**
 * Minimal command for creating or updating a borrower person. Uses minimal DTOs (fewer fields) to improve frontend UX.
 * @export
 * @interface CreateOrUpdateMinimalBorrowerPersonCommandDto
 */
export interface CreateOrUpdateMinimalBorrowerPersonCommandDto {
    /**
     * 
     * @type {CreateOrUpdateMinimalBorrowerNaturalPersonDto}
     * @memberof CreateOrUpdateMinimalBorrowerPersonCommandDto
     */
    naturalPerson?: CreateOrUpdateMinimalBorrowerNaturalPersonDto;
    /**
     * 
     * @type {CreateOrUpdateMinimalBorrowerLegalEntityDto}
     * @memberof CreateOrUpdateMinimalBorrowerPersonCommandDto
     */
    legalEntity?: CreateOrUpdateMinimalBorrowerLegalEntityDto;
    /**
     * 
     * @type {SaveAnswerCommandDto}
     * @memberof CreateOrUpdateMinimalBorrowerPersonCommandDto
     */
    saveAnswersCommand: SaveAnswerCommandDto;
    /**
     * Existing outstanding amount (excluding this project), in euros
     * @type {number}
     * @memberof CreateOrUpdateMinimalBorrowerPersonCommandDto
     */
    existingOutstanding?: number | null;
}

/**
 * Check if a given object implements the CreateOrUpdateMinimalBorrowerPersonCommandDto interface.
 */
export function instanceOfCreateOrUpdateMinimalBorrowerPersonCommandDto(value: object): value is CreateOrUpdateMinimalBorrowerPersonCommandDto {
    if (!('saveAnswersCommand' in value) || value['saveAnswersCommand'] === undefined) return false;
    return true;
}

export function CreateOrUpdateMinimalBorrowerPersonCommandDtoFromJSON(json: any): CreateOrUpdateMinimalBorrowerPersonCommandDto {
    return CreateOrUpdateMinimalBorrowerPersonCommandDtoFromJSONTyped(json, false);
}

export function CreateOrUpdateMinimalBorrowerPersonCommandDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrUpdateMinimalBorrowerPersonCommandDto {
    if (json == null) {
        return json;
    }
    return {
        
        'naturalPerson': json['naturalPerson'] == null ? undefined : CreateOrUpdateMinimalBorrowerNaturalPersonDtoFromJSON(json['naturalPerson']),
        'legalEntity': json['legalEntity'] == null ? undefined : CreateOrUpdateMinimalBorrowerLegalEntityDtoFromJSON(json['legalEntity']),
        'saveAnswersCommand': SaveAnswerCommandDtoFromJSON(json['saveAnswersCommand']),
        'existingOutstanding': json['existingOutstanding'] == null ? undefined : json['existingOutstanding'],
    };
}

export function CreateOrUpdateMinimalBorrowerPersonCommandDtoToJSON(json: any): CreateOrUpdateMinimalBorrowerPersonCommandDto {
    return CreateOrUpdateMinimalBorrowerPersonCommandDtoToJSONTyped(json, false);
}

export function CreateOrUpdateMinimalBorrowerPersonCommandDtoToJSONTyped(value?: CreateOrUpdateMinimalBorrowerPersonCommandDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'naturalPerson': CreateOrUpdateMinimalBorrowerNaturalPersonDtoToJSON(value['naturalPerson']),
        'legalEntity': CreateOrUpdateMinimalBorrowerLegalEntityDtoToJSON(value['legalEntity']),
        'saveAnswersCommand': SaveAnswerCommandDtoToJSON(value['saveAnswersCommand']),
        'existingOutstanding': value['existingOutstanding'],
    };
}

